"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.TextWithCaption = exports.StyledTextWithHtml = exports.Root = exports.MediaWrapper = exports.InnerContent = exports.ContentWrapper = exports.Caption = void 0;
var _mui = require("@ori-ui/mui");
var _editorialFetching = require("@ori/editorial-fetching");
var _presentationComponents = require("@ori/presentation-components");
var _presentationUtils = require("@ori/presentation-utils");
var _VideoLayout = require("../VideoLayout");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  height: 'unset',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    boxSizing: 'border-box',
    height: 500,
    flexDirection: 'row'
  }
}));
const Title = exports.Title = (0, _mui.styled)(_mui.Typography)(() => ({
  display: '-webkit-box',
  WebkitLineClamp: 2,
  lineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden'
}));
const MediaWrapper = exports.MediaWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  width: '100%',
  height: 'unset',
  maxHeight: 'unset',
  order: 0,
  img: {
    aspectRatio: '1/1',
    marginBottom: -1,
    width: '100%',
    maxHeight: 'unset',
    objectFit: 'cover'
  },
  iframe: {
    marginBottom: -1,
    width: '100%',
    display: 'block'
  },
  [`.${_VideoLayout.videoLayoutClasses.video}`]: {
    maxHeight: 500,
    video: {
      margin: '0 auto'
    }
  },
  [theme.breakpoints.up('md')]: {
    width: '50%',
    maxHeight: 500,
    img: {
      aspectRatio: 'auto',
      width: '100%',
      height: 500,
      objectFit: 'cover'
    },
    iframe: {
      height: 500,
      display: 'block'
    }
  }
}));
const ContentWrapper = exports.ContentWrapper = (0, _mui.styled)('div')(({
  theme,
  contentAlignment,
  storybookColor
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  gap: theme.spacing(4, 0),
  width: '100%',
  padding: theme.spacing(6, 3),
  order: 1,
  boxSizing: 'border-box',
  backgroundColor: (0, _presentationUtils.mapBackendColorToTheme)({
    theme,
    backendColor: storybookColor
  }),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(6, 10),
    gap: theme.spacing(6, 0),
    width: '50%',
    height: 500,
    order: contentAlignment === _editorialFetching.HorizontalContentAlignment.Right ? 0 : 1
  }
}));
const InnerContent = exports.InnerContent = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  [theme.breakpoints.up('md')]: {
    maxHeight: 250,
    overflow: 'scroll',
    overflowX: 'hidden',
    gap: theme.spacing(4),
    paddingRight: theme.spacing(3),
    '&::-webkit-scrollbar': {
      width: theme.spacing(2),
      borderRadius: theme.spacing(2)
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.grey[500],
      height: theme.spacing(2)
    },
    '&::-webkit-scrollbar-corner': {
      backgroundColor: theme.palette.grey[500]
    },
    '@supports (scrollbar-width: thin)': {
      scrollbarWidth: 'thin',
      scrollbarColor: `${theme.palette.grey[500]} transparent`
    }
  }
}));
const TextWithCaption = exports.TextWithCaption = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2, 0)
}));
const Caption = exports.Caption = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  fontSize: '1.2rem',
  fontWeight: theme.typography.fontWeightBold,
  letterSpacing: '2.4px',
  textTransform: 'uppercase',
  display: '-webkit-box',
  WebkitLineClamp: 1,
  lineClamp: 1,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden'
}));
const StyledTextWithHtml = exports.StyledTextWithHtml = (0, _mui.styled)(_presentationComponents.TextWithHtml)(({
  theme
}) => ({
  fontSize: '1.4rem'
}));
